import type { CompanyContact } from "../companyTypes";

/** A person at the client as GET /api/companies/:id returns them. */
export interface ClientContact extends CompanyContact {
  willingToAdvocate?: boolean | null;
}

/**
 * GET /api/companies/:id as the Client page reads it. It carries no fee field
 * on purpose: fee terms come only from /api/financials/fee-detail/:id, so
 * the page cannot read one from the company row.
 */
export interface ClientData {
  id: string; name: string; category: string;
  industry: string | null; revenueRange: string | null; ebitda: string | null;
  employeeCount: string | null; description: string | null;
  website: string | null; linkedinUrl: string | null; headquarters: string | null; notes: string | null;
  status: string | null; engagementType: string | null; stage: string | null;
  targetAmount: string | null;
  expectedCloseOn?: string | null; // YYYY-MM-DD; the page edits the month
  daysInMarket: number | null;
  holdReason: string | null; holdDate: string | null; holdRevisitDate: string | null;
  contacts: ClientContact[];
  createdAt?: string; creationSource?: string | null;
  creator?: { id: string; name: string | null } | null;
  enrichmentData?: { phone?: string } | null;
  dualRoleBuyerCp?: boolean | null;
}

export const INDUSTRY_OPTIONS: string[] = ["Healthcare", "Technology", "Manufacturing", "Business Services", "Consumer", "Energy", "Industrial", "Financial Services", "SaaS & Technology", "Transportation & Logistics", "Construction & Infrastructure", "Food & Beverage", "Oilfield Services", "Construction", "HVAC", "Trucking & Logistics", "Concrete / Formwork", "Other"];

export const ENGAGEMENT_TYPES: string[] = ["M&A", "Capital Raise", "Debt Placement", "Restructuring", "ESOP", "Other"];
